import type { IconName } from "@@/shared/icon-name";
import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const contentAutoPageBlockStyleTypes = [
    "cards",
    "circles",
    "pills",
    "squaresWithoutText",
] as const;
type ContentAutoPageBlockStyleType =
    (typeof contentAutoPageBlockStyleTypes)[number];
const contentAutoPageBlockStyleType =
    toObjectMap<ContentAutoPageBlockStyleType>([
        ...contentAutoPageBlockStyleTypes,
    ]);
const contentAutoPageBlockStyleTypeMeta: Record<
    ContentAutoPageBlockStyleType,
    {
        iconName: IconName;
        name: Translatable;
    }
> = {
    cards: {
        iconName: "fa-cards-blank",
        name: translation({
            sv: "Kort",
            en: "Cards",
        }),
    },
    circles: {
        iconName: "fa-circle",
        name: translation({
            sv: "Cirklar",
            en: "Circles",
        }),
    },
    squaresWithoutText: {
        iconName: "fa-square",
        name: translation({
            sv: "Kvadrater (utan text)",
            en: "Squares (without text)",
        }),
    },
    pills: {
        iconName: "fa-pills",
        name: translation({
            sv: "Piller",
            en: "Pills",
        }),
    },
};
const contentAutoPageBlockStyleTypeZodSchema = z.enum(
    contentAutoPageBlockStyleTypes,
);

export {
    contentAutoPageBlockStyleType,
    contentAutoPageBlockStyleTypeMeta,
    contentAutoPageBlockStyleTypeZodSchema,
};
export type { ContentAutoPageBlockStyleType };
